export const ACTIONS = {
  PUSH_STUDENT_EVENT: 'PUSH_STUDENT_EVENT',
  PUSH_STUDENT_EVENTS: 'PUSH_STUDENT_EVENTS',
  CLEAR_STUDENT_EVENTS: 'CLEAR_STUDENT_EVENTS',
};

export const pushEvent = event => (dispatch) => {
  dispatch({
    type: ACTIONS.PUSH_STUDENT_EVENT,
    payload: {
      event,
    },
  });
};
export const pushEvents = events => (dispatch) => {
  dispatch({
    type: ACTIONS.PUSH_STUDENT_EVENTS,
    payload: {
      events,
    },
  });
};

export const clearEvents = events => (dispatch) => {
  dispatch({
    type: ACTIONS.CLEAR_STUDENT_EVENTS,
    payload: {
      events,
    },
  });
};
